import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetB2BBeneficiaryStatus,
	GetB2BBeneficiaryStatusModel,
	GetB2BBeneficiaryStatusParams,
} from 'domain/usecases/others/selection-flow/b2b/get-b2b-beneficiary-status';

export class RemoteGetB2BBeneficiaryStatus implements GetB2BBeneficiaryStatus {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetB2BBeneficiaryStatusModel>,
	) {}

	async get(params: GetB2BBeneficiaryStatusParams): Promise<GetB2BBeneficiaryStatusModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
